var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonConverter } from "json2typescript";
import { CustomConverterUtils } from "../../../util/utils";
/**
 * @category Internal
 */
var IdConverter = /** @class */ (function () {
    function IdConverter() {
    }
    IdConverter.prototype.serialize = function (id) {
        return {
            "@id": id
        };
    };
    IdConverter.prototype.deserialize = function (item) {
        if (Array.isArray(item))
            throw new Error("Expected a single element instead of Array");
        if (item.hasOwnProperty("@id") && CustomConverterUtils.isString(item["@id"])) {
            return item["@id"];
        }
        else {
            throw new Error("Expected @id property");
        }
    };
    IdConverter = __decorate([
        JsonConverter
    ], IdConverter);
    return IdConverter;
}());
export { IdConverter };
